<template>
  <div
    ref="container"
    :class="{
      'relative': !isAllContactsFit,
      'flex justify-center flex-row': isAllContactsFit,
    }"
    :style="{
      height: `${CONTACT_WIDTH}px`
    }"
  >
    <contact-avatar
      v-for="(contact, idx) in contactsSlice"
      :key="contact.id"
      :contact
      :size="32"
      :class="{
        absolute: !isAllContactsFit
      }"
      :style="{
        left: `${widthPerOneContact * idx}px`,
        zIndex: idx,
        width: `${CONTACT_WIDTH}px`,
        height: `${CONTACT_WIDTH}px`,
      }"
    />
    <div
      v-if="!isAllContactsFit"
      class="absolute bg-primary-tints-150 border border-primary-tints-100 flex justify-center items-center text-1000 w-10 h-10 rounded-full text-1624"
      :style="{
        zIndex: containerCapacity + 1,
        left: `${widthPerOneContact * (containerCapacity - 2)}px`
      }"
    >
      +{{ hiddenContactsCount }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import { ContactAvatar } from '@/entities/contact-avatar'

import { Contact } from '@/shared/types/api'


const props = defineProps<{
  contacts: Contact[]
}>()

const CONTACT_WIDTH = 40
const containerCapacity = computed(() => Math.floor(containerWidth.value / (CONTACT_WIDTH / 2)) - 1)
const isAllContactsFit = computed(() => containerCapacity.value >= props.contacts.length)
const widthPerOneContact = computed(() => containerWidth.value / containerCapacity.value)
const hiddenContactsCount = computed(() => props.contacts.length - containerCapacity.value + 2)

const contactsSlice = computed(() => {
  if (isAllContactsFit.value) {
    return props.contacts
  } else {
    return props.contacts.slice(0, containerCapacity.value - 1)
  }
})

const container = ref<HTMLDivElement | null>(null)
const containerWidth = ref(0)
const resizeObserver = new ResizeObserver(() => {
  containerWidth.value = container.value?.offsetWidth || 0
})
onMounted(() => {
  if (container.value) {
    resizeObserver.observe(container.value)
  }
})
</script>
